import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-cream py-16 sm:py-20" data-id="element-78" data-mp="1ckwngh3iixq5">
      <div className="mx-auto max-w-5xl px-5" data-id="element-79" data-mp="1clpk2p8rc6uk">
        <p className="mx-auto flex w-fit items-center gap-2 rounded-full bg-cta px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-80" data-mp="18jukpqae03jf">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="259bq045gjnkl" /> Included free today
        </p>
        <h2 className="mt-5 text-center font-serif text-[30px] leading-tight sm:text-5xl font-extrabold text-ink" data-id="element-82" data-mp="20c1ymiyid1u4">
          5 exclusive bonuses worth <em className="text-brand-600" data-id="element-83" data-mp="1ra2kpzisidve">$171</em>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] text-muted" data-id="element-84" data-mp="1r9kdk7ulaf8p">
          All included free with your $27 purchase.
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-5xl space-y-8 sm:space-y-10 sm:px-5" data-id="element-85" data-mp="fudv10e5j0qw">
        {bonuses.map((b, i) => <article key={b.number} className={`overflow-hidden bg-white sm:rounded-3xl shadow-[0_20px_50px_-30px_rgba(38,16,64,0.35)] md:grid md:grid-cols-2 md:items-center ${i % 2 === 1 ? 'md:[&>img]:order-2' : ''}`} data-id="element-86" data-mp="1euq24g36je2p" data-mpi={i}>
            <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full h-auto" loading="lazy" data-id="element-87" data-mp="1arjx1brszsxt" />
            <div className="p-6 sm:p-8" data-id="element-88" data-mp="w248m2fqvzla">
              <div className="flex flex-wrap items-center gap-3" data-id="element-89" data-mp="w12n1413rupb">
                <span className="rounded-lg bg-brand-700 px-3 py-1 text-sm font-extrabold uppercase text-white" data-id="element-90" data-mp="10unm6zefmuq3">
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-semibold text-muted" data-id="element-91" data-mp="r3kjjt5uu7op">
                  Value: <s data-id="element-92" data-mp="d4b5az17lnnd">${b.value}</s> <span className="font-extrabold text-cta" data-id="element-93" data-mp="d3rojlnap5ax">FREE</span>
                </span>
              </div>
              <h3 className="mt-4 font-serif text-2xl sm:text-3xl font-bold leading-tight text-ink" data-id="element-94" data-mp="i3nsxlzwmyr0">{b.title}</h3>
              <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-95" data-mp="2jtd77wjpwv6v">{b.description}</p>
              <ul className="mt-5 space-y-2.5" data-id="element-96" data-mp="2f0se6x8mym4e">
                {b.points.map(pt => <li key={pt} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-97" data-mp="2azgoystoc2wq">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-98" data-mp="261osrmlzxumq">
                      <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-99" data-mp="32q4oy1jm328t" />
                    </span>
                    {pt}
                  </li>)}
              </ul>
            </div>
          </article>)}
      </div>

      <div className="mt-10 px-5" data-id="element-100" data-mp="2orwqtqau9uw2">
        <CtaButton label="I want all 5 bonuses" data-id="element-101" data-mp="2oqv6swbuhy27" />
      </div>
    </section>;
}